import {$} from "./Dom.ts";

export type StepperOptions = {
    selectors: {
        title: string
        state: string
        steps: string
        nextStep: string
    },
}

export class Stepper extends EventTarget {
    private options: StepperOptions = {
        selectors: {
            title: '.fr-stepper__title',
            state: '.fr-stepper__state',
            steps: '.fr-stepper__steps',
            nextStep: '.fr-stepper__details'
        }
    }

    private _currentStep = 1

    private parentElement: HTMLElement

    get currentStep() {
        return this._currentStep
    }

    constructor(selector: string, options?: Partial<StepperOptions>) {
        super()
        Object.assign(this.options, this.options, options)
        this.parentElement = $(selector)!
        this.parentElement.addEventListener('click', this.handlePrevNext.bind(this))
    }

    private handlePrevNext(event: DOMEvent<HTMLElement>) {
        let endElement: HTMLElement
        const startElement = $<HTMLElement>(`[data-step='${this._currentStep}']`)!
        if(event.target.classList.contains('stepper-prev')) {
            endElement = $<HTMLElement>(`[data-step='${this._currentStep - 1}']`)!
            this._currentStep--
        } else if(event.target.classList.contains('stepper-next')) {
            endElement = $<HTMLElement>(`[data-step='${this._currentStep + 1}']`)!
            this._currentStep++
        } else {
            return;
        }
        this.handleCase(startElement, endElement)
    }

    private handleCase(startElement: HTMLElement, endElement: HTMLElement) {
        this.dispatchEvent(new CustomEvent('stepper:change', { detail: { step: this._currentStep } }))
        startElement.classList.add('animate__animated', 'animate__fadeOut', 'animate__faster')
        startElement.addEventListener('animationend', () => {
            this.update(endElement)
            startElement.classList.add('d-none')
            startElement.classList.remove('animate__fadeOut')
            endElement.classList.remove('d-none')
            endElement.classList.add('animate__animated', 'animate__fadeIn', 'animate__faster')
        }, {once: true})
    }

    private update(currentElement: HTMLElement) {
        $<HTMLElement>(this.options.selectors?.title)!.innerHTML = `<span class="fr-stepper__state">Étape ${currentElement.dataset.step} sur 3</span>${(currentElement.dataset.title as string)}`
        const stateElement = $<HTMLElement>(this.options.selectors.state)!
        const stepsElement = $<HTMLElement>(this.options.selectors.steps)
        stateElement.innerText = `Étape ${currentElement.dataset.step} sur ${stepsElement?.getAttribute('data-fr-steps')}`

        stepsElement?.setAttribute('data-fr-current-step', (currentElement.dataset.step as string))
        $<HTMLElement>(this.options.selectors?.nextStep)!.innerHTML = `<span class="fr-text--bold">Étape suivante :</span> ${currentElement.getAttribute('data-next-step')}`
    }
}